module.exports = __webpack_public_path__ + "b5b0f07380bac6fcb86fa081e55622b6.mp4";